var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
const SvgTrendingUp = _a => {
  var _b, _c;
  var {
      size
    } = _a,
    props = __rest(_a, ["size"]);
  return React.createElement("svg", Object.assign({
    width: size !== null && size !== void 0 ? size : 24,
    height: size !== null && size !== void 0 ? size : 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: props.role,
    "aria-hidden": (_b = props['aria-hidden']) !== null && _b !== void 0 ? _b : true
  }, props), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.6028 7.40426H16.6809C16.2931 7.40426 15.9787 7.0899 15.9787 6.70213C15.9787 6.31435 16.2931 6 16.6809 6H22.2979C22.6856 6 23 6.31435 23 6.70213V12.3191C23 12.7069 22.6856 13.0213 22.2979 13.0213C21.9101 13.0213 21.5957 12.7069 21.5957 12.3191V8.39721L13.9007 16.0922C13.6265 16.3664 13.182 16.3664 12.9078 16.0922L8.7234 11.9079L2.19861 18.4326C1.92441 18.7068 1.47985 18.7068 1.20565 18.4326C0.931451 18.1585 0.931451 17.7139 1.20565 17.4397L8.22692 10.4184C8.50112 10.1442 8.94569 10.1442 9.21988 10.4184L13.4043 14.6028L20.6028 7.40426Z",
    fill: (_c = props.color) !== null && _c !== void 0 ? _c : 'currentColor'
  }));
};
export default SvgTrendingUp;